import React from 'react';
import BrandDetail from '../components/BrandDetail';

const Oaken = () => {
  return <BrandDetail brandSlug="oaken" />;
};

export default Oaken;
